import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { CoverageListsPanel } from '@/components/reports/CoverageListsPanel'
import { accountQuery, coverageListsQuery, sessionQuery } from '@/lib/queries'
import { isStaff } from '@/lib/viewer'

/**
 * A client workspace's Coverage lists — the account's lists (clients inherit them; there is no
 * per-client set) rendered at a client-scoped URL so the sidebar, switcher, and breadcrumb stay in
 * the client's context. Same panel and gating as the account route.
 */
export const Route = createFileRoute(
  '/app/accounts/$accountId_/subaccounts/$subaccountId/coverage-lists',
)({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(accountQuery(params.accountId)),
      context.queryClient.ensureQueryData(coverageListsQuery(params.accountId)),
    ]),
  component: ClientCoverageListsPage,
})

function ClientCoverageListsPage() {
  const { accountId } = Route.useParams()
  const { data: session } = useSuspenseQuery(sessionQuery)
  return <CoverageListsPanel accountId={accountId} canManageGlobals={isStaff(session.user)} />
}
